import React from 'react';
import { modelClass } from '/imports/api/priceSources';
import { ModelListPage } from '/imports/ui/ModelListPage';
import { useUser } from '/imports/hooks';

export const PriceSourcesPage = () => (
  <ModelListPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    columns={[{ field: 'type', label: 'Type' }, { field: 'url', label: 'URL' }]}
  />
);

// keep unused import live so tree-shaking doesn't drop the hook
void useUser;
